var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnhideNodesDarkBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Navigation",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157145",
    "data-name": "Rectangle 157145",
    width: 38,
    height: 38,
    rx: 8,
    transform: "translate(38) rotate(90)",
    fill: "#2e4d7b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157085",
    "data-name": "Rectangle 157085",
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "visibility_20dp_5F6368_FILL0_wght400_GRAD0_opsz20",
    d: "M69.222-756.928a3.934,3.934,0,0,0,2.889-1.19,3.934,3.934,0,0,0,1.19-2.889,3.934,3.934,0,0,0-1.19-2.889,3.934,3.934,0,0,0-2.889-1.19,3.934,3.934,0,0,0-2.889,1.19,3.934,3.934,0,0,0-1.19,2.889,3.934,3.934,0,0,0,1.19,2.889A3.934,3.934,0,0,0,69.222-756.928Zm0-1.748a2.248,2.248,0,0,1-1.651-.68,2.248,2.248,0,0,1-.68-1.651,2.248,2.248,0,0,1,.68-1.651,2.248,2.248,0,0,1,1.651-.68,2.248,2.248,0,0,1,1.651.68,2.248,2.248,0,0,1,.68,1.651,2.248,2.248,0,0,1-.68,1.651A2.248,2.248,0,0,1,69.222-758.676Zm0,4.662a10.58,10.58,0,0,1-5.8-1.687,12.4,12.4,0,0,1-4.2-4.456,1.317,1.317,0,0,1-.17-.407A1.959,1.959,0,0,1,59-761a2.034,2.034,0,0,1,.049-.443,1.31,1.31,0,0,1,.17-.413,12.4,12.4,0,0,1,4.2-4.456,10.58,10.58,0,0,1,5.8-1.687,10.58,10.58,0,0,1,5.8,1.688,12.4,12.4,0,0,1,4.2,4.456,1.316,1.316,0,0,1,.17.407,1.959,1.959,0,0,1,.049.437,2.034,2.034,0,0,1-.049.443,1.31,1.31,0,0,1-.17.413,12.4,12.4,0,0,1-4.2,4.456A10.58,10.58,0,0,1,69.222-754.014ZM69.222-761.007Zm0,5.245a9.467,9.467,0,0,0,5.026-1.408,9.423,9.423,0,0,0,3.545-3.836,9.422,9.422,0,0,0-3.545-3.836,9.466,9.466,0,0,0-5.026-1.408,9.466,9.466,0,0,0-5.026,1.408,9.422,9.422,0,0,0-3.545,3.836,9.423,9.423,0,0,0,3.545,3.836A9.467,9.467,0,0,0,69.222-755.763Z",
    transform: "translate(-57.222 773.007)",
    fill: "#f5f6f8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhideNodesDarkBackground);
export default __webpack_public_path__ + "static/media/UnhideNodesDarkBackground.4e58610a2b914c58569471f4cf804a2f.svg";
export { ForwardRef as ReactComponent };